import { useState, useEffect, useCallback, useRef } from 'react';
import { simStudioApi } from '../api/simStudioApi';
import type { LiveStats } from '../api/simStudioApi';

export function useSchoolStats(escolaId: string | null, pollMs = 10000) {
  const [stats, setStats] = useState<LiveStats | null>(null);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetch = useCallback(async () => {
    if (!escolaId) return;
    try {
      const data = await simStudioApi.getLiveStats(escolaId);
      setStats(data);
    } catch {
      // silencioso — mantém último valor
    } finally {
      setLoading(false);
    }
  }, [escolaId]);

  useEffect(() => {
    if (!escolaId) { setStats(null); return; }
    setLoading(true);
    fetch();
    timerRef.current = setInterval(fetch, pollMs);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [escolaId, pollMs, fetch]);

  return { stats, loading };
}
